import styled, { Spacing, Color } from '@nfinite/react-hubstairs/styled'
import IconComponent from 'components/Commons/Icon'
import ButtonComponent from 'components/Commons/Button'

const CIRCLE_WIDTH = 60
const RIGHT_POSITION_OFFSET = 30
const ARROW_ICON_WIDTH = 16
const ARRW_ICON_HEIGHT = 20

export const Container = styled('div')`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
`
export const Position = styled('div')`
  position: fixed;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  bottom: ${({ visible, distanceFromBottom }) => (visible ? '28px' : `${distanceFromBottom}px`)};
  z-index: 9980;
  transition: all 0.3s ease-out;
  right: ${RIGHT_POSITION_OFFSET}px;
`

export const ArrowIcon = styled(IconComponent)`
  height: ${ARRW_ICON_HEIGHT}px;
  width: ${ARROW_ICON_WIDTH}px;
`

export const Button = styled(ButtonComponent)`
  width: ${CIRCLE_WIDTH}px;
  height: ${CIRCLE_WIDTH}px;
  min-width: ${CIRCLE_WIDTH}px;
  padding: 0;
  background: ${Color.get('white')};
  border-radius: 50%;
  border: none;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  &:hover {
    background: ${Color.get('white')};
  }
  &:hover span {
    color: ${Color.get('secondary')};
  }
`
export const Content = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${Spacing.get('xs')}px;
  & > span {
    color: ${Color.get('secondary')};
  }
`
